import React, { useState, useContext } from "react";
import "./App.css";
import Discover from "./components/Discover";
import Library from "./components/Library";
import logo from "./imgs/book-logo.svg";
import Avatar from "@material-ui/core/Avatar";
import BestAuthersList from "./components/BestAuthersList";
import Nav from "./components/Nav";
import Home from "./pages/Home";
import ForYou from "./pages/ForYou";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import {
  Provider,
  BasketProvider,
  UserContext,
} from "./components/context/Context";
import BookPreview from "./pages/BookPreview";
import Basket from "./pages/Basket";
import Browes from "./pages/Browes";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { auth, provider } from "./Firebase";
import Login from "./pages/Login";
import MobileNav from "./components/mobile/MobileNav";

function App() {
  const [user, setUser] = useContext(UserContext);
  const signIn = () => {
    auth.signInWithPopup(provider).catch((err) => alert(err.message));
  };

  const logOut = () => {
    auth.signOut();
  };

  return (
    <Provider>
      <BasketProvider>
        {user ? (
          <Router>
            <div className="app">
              <div className="mobile">
                <MobileNav />
                <div>
                  <Switch>
                    <Route exact path="/" component={Home} />
                    <Route path="/ForYou" component={ForYou} />
                    <Route path="/Browse" component={Browes} />
                    <Route path="/BookPreviwe" component={BookPreview} />
                    <Route path="/Basket" component={Basket} />
                  </Switch>
                </div>
              </div>
              <div className="leftSide">
                <div className="leftSide__logo">
                  <img src={logo} alt="logo" />
                </div>
                <Discover />
                <Library />
              </div>
              <div className="middleSide">
                <Nav />
                <Switch>
                  <Route exact path="/" component={Home} />
                  <Route path="/ForYou" component={ForYou} />
                  <Route path="/Browse" component={Browes} />
                  <Route path="/BookPreviwe" component={BookPreview} />
                  <Route path="/Basket" component={Basket} />
                </Switch>
              </div>
              <div className="rightSide">
                <div className="rightSide__user">
                  <Avatar src={user?.photoURL} />
                  <div className="user__info">
                    <p>{user?.displayName}</p>
                    <span>{user?.email}</span>
                  </div>
                  <ExitToAppIcon className="logOutBtn" onClick={logOut} />
                </div>
                <BestAuthersList />
              </div>
            </div>
          </Router>
        ) : (
          <Login />
        )}
      </BasketProvider>
    </Provider>
  );
}

export default App;
